"use client";

import { Button } from "@repo/ui/components/ui/button";
import { useTranslations } from "next-intl";
import Icon from "@repo/ui/components/ui/icon/icon";
import { signIn } from "next-auth/react";
import { ButtonProps } from "@repo/ui/components/ui/button";

export default function SignIn({ variant = "outline" }: ButtonProps) {
  const t = useTranslations();

  return (
    <Button
      variant={variant}
      className="sign-in"
      onClick={() => signIn("keycloak", { redirectTo: "/products/catalog" })}
    >
      <span className="max-md:hidden">{t("signin")}</span>
      <Icon
        icon="AccountCircle"
        className="h-[24px] w-[24px] hidden max-md:block"
      />
    </Button>
  );
}
